import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {useStylesBox} from './styleCustom';
import currencies from '../../../constants/currencies';

interface CurrencySelectorProps {
    selectValue: {[key: string]: string};
    setAddObj: React.Dispatch<React.SetStateAction<any>>;
};

const CurrencySelector = ({selectValue, setAddObj}: CurrencySelectorProps) => {
    const classesInput = useStylesBox();
    return (
        <Select
        style={{width: '150px', height: '56px', padding: '6px 10px', marginRight: '0.2rem', fontSize: '16px', fontWeight: 400, textTransform: 'uppercase', background: 'white', borderRadius: '26px', borderBottom: '1px solid rgba(217, 217, 217, 0.6)'}}
        className={classesInput.textField}
        labelId="currency-selector"
        id="currency-selector"
        value={selectValue.currency}
        onChange={(e: any) => setAddObj({...selectValue, currency: e.target.value})}
        onBlur={(e: any) => setAddObj({...selectValue, currency: e.target.value})}
    >
        {Object.keys(currencies).map((val) => <MenuItem style={{textTransform: 'uppercase'}} key={`currency-name-${val}`} value={val}>{val}</MenuItem>)}
    </Select>
    );
};

export default CurrencySelector;
